import { useState } from "react";

import Dialog from "./Dialog";

import RemoveIcon from "../../../../../../components/RemoveIcon";

const RemoveButton = ({ groupId, recipientId }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};
	return (
		<>
			<RemoveIcon onClick={handleClickOpen} />
			<Dialog
				open={open}
				onClose={handleClose}
				groupId={groupId}
				recipientId={recipientId}
			/>
		</>
	);
};

export default RemoveButton;
